/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import CustomSelect from '@tcp/core/src/components/common/molecules/CustomSelect';
import Modal from '@tcp/core/src/components/common/molecules/Modal';
import { getViewportInfo, isClient } from '@tcp/core/src/utils';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { change, Field, reduxForm } from 'redux-form';
import { BRAND_NAMES } from '@tcp/core/src/constants/pageTitle.constants';
import { getIconPath, getLocator } from '../../../../../../../../../utils';
import BodyCopy from '../../../../../../../../common/atoms/BodyCopy';
import Button from '../../../../../../../../common/atoms/Button';
import Col from '../../../../../../../../common/atoms/Col';
import Image from '../../../../../../../../common/atoms/Image';
import InputCheckbox from '../../../../../../../../common/atoms/InputCheckbox';
import LabeledRadioButton from '../../../../../../../../common/atoms/LabeledRadioButton';
import Row from '../../../../../../../../common/atoms/Row';
import withStyles from '../../../../../../../../common/hoc/withStyles';
import GIFT_SERVICES_CONSTANTS from '../GiftServices.constants';
import styles from '../styles/GiftServices.style';
import GiftServicesDetailsModal from './GiftServicesDetailsModal.view';
import ShippingPageLabels, {
  ADDRESS_LABELS,
  SHIPPING_LABELS,
} from '../../../views/ShippingPage.labels';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../../../utils/labels/labelUtilty';

const MAX_LENGTH = 100;

const getInitialValues = (ownProps) => {
  const { savedGiftService = {}, spc = false, initialValues = {} } = ownProps || {};
  return spc ? { ...savedGiftService } : initialValues;
};

const getTextFieldHeadingText = (labels, maxLength, message, textFieldMessage = '') => {
  const shippingPageLabels = getLabelFromCopyOrFromTranslation(SHIPPING_LABELS, ShippingPageLabels);
  return (
    <>
      <Row fullBleed className="messageTextWrapper">
        <Col colSize={{ small: 3, medium: 3, large: 3 }}>
          <BodyCopy color="gray.900" fontSize="fs14" fontFamily="secondary" textAlign="left">
            {renderLabel(
              shippingPageLabels?.lbl_giftServices_addMessage,
              'lbl_giftServices_addMessage'
            )}
          </BodyCopy>
        </Col>
        <Col colSize={{ small: 3, medium: 3, large: 3 }}>
          <BodyCopy color="gray.900" fontSize="fs12" fontFamily="secondary" textAlign="right">
            {renderLabel(
              shippingPageLabels?.lbl_giftServices_charLimit,
              'lbl_giftServices_charLimit'
            ) &&
              `${renderLabel(
                shippingPageLabels?.lbl_giftServices_charLimit,
                'lbl_giftServices_charLimit'
              ).substr(4)} ${textFieldMessage.length}/${MAX_LENGTH}`}
          </BodyCopy>
        </Col>
      </Row>
      <Row className="edit-form-css" fullBleed>
        <Col colSize={{ small: 6, medium: 6, large: 6 }}>
          <Field
            name="message"
            value={message}
            normalize={maxLength(MAX_LENGTH)}
            id="message"
            component="textarea"
            dataLocator="gift-message"
            className="gift-message"
          />
        </Col>
      </Row>
    </>
  );
};

const getGiftServicesContent = ({ isMobileView, isShippingCheckboxSelected }) => {
  return isMobileView || isShippingCheckboxSelected;
};

const getIconDimensions = ({ isMobileView }) => {
  let iconHeight = '22px';
  let iconWidth = '21px';
  if (isMobileView) {
    iconHeight = '27px';
    iconWidth = '26px';
  }
  return { iconHeight, iconWidth };
};

export const GiftServicesHeaderContent = ({
  isMobileView,
  labels,
  addGiftServicesTitle,
  handleChange,
  isModalOpen,
}) => {
  const mobileViewOpen = isMobileView && isModalOpen;
  const { iconHeight, iconWidth } = getIconDimensions({ isMobileView });
  return (
    <Row fullBleed>
      <Col colSize={{ small: 6, medium: 8, large: 12 }}>
        <div className={`checkbox-header ${mobileViewOpen ? '' : 'elem-mt-LRG'}`}>
          <Field
            name="hasGiftWrapping"
            component={InputCheckbox}
            dataLocator={getLocator('gift_service')}
            enableSuccessCheck={false}
            onChange={(e) => handleChange(e)}
            className={`giftServicesField ${mobileViewOpen ? 'no-visile' : ''}`}
            labels={labels}
            ariaLabel={addGiftServicesTitle}
            spc
          />
          <Row fullBleed className={`checkbox-header title ${mobileViewOpen ? 'no-visile' : ''}`}>
            <Image
              className={`header-icon ${!mobileViewOpen ? 'elem-pl-SM' : ''}`}
              width={iconWidth}
              height={iconHeight}
              src={getIconPath('gift-services')}
              alt="mailing-address"
            />
            <BodyCopy
              component="div"
              className="gift-header elem-pl-XS elem-mt-XXXS"
              fontFamily="secondary"
              fontWeight="semibold"
              fontSize={isMobileView ? 'fs18' : 'fs14'}
            >
              {addGiftServicesTitle}
            </BodyCopy>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

class GiftServices extends React.PureComponent {
  shippingPageLabels = getLabelFromCopyOrFromTranslation(SHIPPING_LABELS, ShippingPageLabels);

  addressLabels = getLabelFromCopyOrFromTranslation(ADDRESS_LABELS, ShippingPageLabels);

  constructor(props) {
    super(props);
    const { isGiftServicesChecked, initialValues } = this.props;
    this.state = {
      detailStatus: false,
      isChecked: isGiftServicesChecked,
      message: initialValues.message,
      isModalOpen: false,
      isNoneSelected: false,
    };
  }

  handleChange = (e) => {
    const { isChecked } = this.state;
    const { handleAnalytics, deselectCallback } = this.props;
    const hasGiftWrapping = !isChecked;
    this.setState({
      isChecked: hasGiftWrapping,
    });

    e.currentTarget.blur();

    handleAnalytics();
    if (!hasGiftWrapping) {
      deselectCallback();
    } else {
      this.selectDefaultOption();
    }
  };

  handleMobileSaveAndContinue = () => {
    const {
      giftServicesInputs: { optionId, message, brand },
      savedGiftService: { optionId: savedOptionId },
    } = this.props;
    const updatedGiftServicesForm =
      optionId === GIFT_SERVICES_CONSTANTS.GIFT_SERVICES_OPTION_NONE
        ? { hasGiftWrapping: false, optionId: savedOptionId }
        : { hasGiftWrapping: true, optionId, brand, message };
    this.updateGiftServicesForm(updatedGiftServicesForm);
    this.toggleModalVisibility({ isModalOpen: false });
  };

  toggleModalVisibility = ({ isModalOpen = false }) => {
    this.setState({ isModalOpen });
  };

  handleModalOpen = () => {
    const { giftServicesInputs } = this.props;
    this.updateGiftServicesForm(giftServicesInputs);
    this.toggleModalVisibility({ isModalOpen: true });
    if (!giftServicesInputs?.optionId) {
      // If no option is selected when opening gift services modal on mobile
      // Then select default option
      this.selectDefaultOption();
    }
  };

  handleModalCancel = () => {
    const { savedGiftService } = this.props;
    this.toggleModalVisibility({ isModalOpen: false });
    this.updateGiftServicesForm(savedGiftService);
  };

  /**
   * Selects default option if gift services has been toggled on
   */
  selectDefaultOption = () => {
    const { giftServicesInputs, giftWrapOptions, labels, dispatch } = this.props;
    if (!giftServicesInputs?.hasGiftWrapping) {
      const isMobileView = isClient() && getViewportInfo().isMobile;
      const giftServicesList = this.getServicesOptions(giftWrapOptions, labels, isMobileView);
      dispatch(change('GiftServices', 'message', ''));
      dispatch(change('GiftServices', 'optionId', giftServicesList[0]?.value));
    }
  };

  updateGiftServicesForm = ({ hasGiftWrapping, message, optionId, brand }) => {
    const { dispatch } = this.props;
    dispatch(change('GiftServices', `hasGiftWrapping`, hasGiftWrapping));
    dispatch(change('GiftServices', `message`, message));
    dispatch(change('GiftServices', `optionId`, optionId));
    dispatch(change('GiftServices', `brand`, brand));
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  getServicesOptions = (giftWrapOptions, labels, isMobileView) => {
    const { SelectedBrand, spc } = this.props;
    const parsedGiftWrapOptions = giftWrapOptions ? JSON.parse(giftWrapOptions) : {};
    const getServicesOptionsMap = parsedGiftWrapOptions?.giftOptions;

    const giftServicesOptions =
      getServicesOptionsMap &&
      getServicesOptionsMap
        .filter(
          (servicesMap) =>
            servicesMap.itemBrand === SelectedBrand || servicesMap.itemBrand === 'ALL'
        )
        .map((servicesMap) => {
          return {
            title: (
              <React.Fragment>
                <div className={spc ? 'spc-gift-service-option-container' : ''}>
                  <span>{servicesMap.name}</span>
                  <span className={`price ${spc ? 'spc-gift-service-option-price' : ''}`}>
                    {servicesMap.price === 0
                      ? renderLabel(
                          getDynamicLabelValues(
                            'dynamic.checkout_d.lbl_shipping_giftServicesTcpOptionPrice1'
                          ),
                          'lbl_shipping_giftServicesTcpOptionPrice1'
                        )
                      : `$${servicesMap.price}`}
                  </span>
                </div>
              </React.Fragment>
            ),
            content: (
              <React.Fragment>
                <div className="shortDesc">
                  <span>{servicesMap.name}</span>
                  <span className="price">
                    {servicesMap.price === 0
                      ? renderLabel(
                          getDynamicLabelValues(
                            'dynamic.checkout_d.lbl_shipping_giftServicesTcpOptionPrice1'
                          ),
                          'lbl_shipping_giftServicesTcpOptionPrice1'
                        )
                      : `$${servicesMap.price}`}
                  </span>
                </div>
                <div className="longDescSection">
                  <span className="longDesc">{servicesMap.longDescription}</span>
                </div>
              </React.Fragment>
            ),
            value: servicesMap.catEntryId,
          };
        });
    if (isMobileView && giftServicesOptions) {
      giftServicesOptions.push({
        title: (
          <React.Fragment>
            <div className={spc ? 'spc-gift-service-option-container' : ''}>
              <span>
                {renderLabel(
                  this.shippingPageLabels?.lbl_gift_service_option_none,
                  'lbl_gift_service_option_none'
                ) || 'None'}
              </span>
            </div>
          </React.Fragment>
        ),
        content: (
          <React.Fragment>
            <div className="shortDesc">
              <span>
                {renderLabel(
                  this.shippingPageLabels?.lbl_gift_service_option_none,
                  'lbl_gift_service_option_none'
                ) || 'None'}
              </span>
            </div>
          </React.Fragment>
        ),
        value: GIFT_SERVICES_CONSTANTS.GIFT_SERVICES_OPTION_NONE,
      });
    }
    return giftServicesOptions;
  };

  giftServiceChanged = (e, value) => {
    const { dispatch } = this.props;
    /* istanbul ignore else */
    if (dispatch) {
      dispatch(change('GiftServices', `optionId`, value));
    }
  };

  getActiveTitle = (options = [], value) => {
    const { dispatch } = this.props;
    const selectedOption = options.find((o) => o.value === value);
    this.setState({ isNoneSelected: false });
    if (!selectedOption) {
      const defaultOption = options.find((o) => o.value === 'standard');
      return defaultOption && defaultOption.title;
    }
    if (selectedOption.value === GIFT_SERVICES_CONSTANTS.GIFT_SERVICES_OPTION_NONE) {
      this.setState({ isNoneSelected: true });
      dispatch(change('GiftServices', 'message', ''));
    }
    return selectedOption.title;
  };

  getMobileViewTitle = (giftServicesList) => {
    const { isModalOpen } = this.state;
    const { giftServicesInputs: { optionId = '', hasGiftWrapping } = {} } = this.props;
    let activeTitle = renderLabel(
      this.shippingPageLabels?.lbl_add_gift_services,
      'lbl_add_gift_services'
    );
    const updatedTile = giftServicesList && giftServicesList.find((o) => o.value === optionId);
    if (updatedTile && !isModalOpen && hasGiftWrapping) {
      activeTitle = updatedTile.title;
    }
    return activeTitle;
  };

  render() {
    const { className, labels, giftWrapOptions, handleToggle, SelectedBrand, giftServicesInputs } =
      this.props;

    const { hasGiftWrapping: isShippingCheckboxSelected, message: textFieldMessage } =
      giftServicesInputs || {};
    const isMobileView = isClient() && getViewportInfo().isMobile;
    const giftServicesList = this.getServicesOptions(giftWrapOptions, labels, isMobileView);
    const { detailStatus, message, isModalOpen, isNoneSelected } = this.state;

    const MainContainer = isMobileView ? Modal : BodyCopy;

    const maxLength = (max) => (value) => {
      let v;
      const result = value.length > max;
      if (result === false) {
        v = value;
      }
      return v;
    };

    const addGiftServicesTitle = renderLabel(
      this.shippingPageLabels?.lbl_add_gift_services,
      'lbl_add_gift_services'
    );

    return (
      <form className={className} noValidate>
        {isMobileView && (
          <div className="checkbox-header">
            <Field
              name="hasGiftWrapping"
              component={InputCheckbox}
              dataLocator={getLocator('gift_service')}
              enableSuccessCheck={false}
              onChange={this.handleModalOpen}
              className="giftServicesField"
              labels={labels}
              spc
            />
            <Row fullBleed className="checkbox-header title g ">
              <Image
                className="header-icon elem-pl-SM"
                width="21px"
                height="22px"
                src={getIconPath('gift-services')}
                alt="gift-services"
              />
              <BodyCopy
                component="div"
                className="elem-pl-XS elem-mt-XXXS mobile-title"
                fontFamily="secondary"
                fontWeight="semibold"
                fontSize="fs14"
              >
                {this.getMobileViewTitle(giftServicesList)}
              </BodyCopy>
            </Row>
          </div>
        )}
        <MainContainer
          isOpen={isModalOpen}
          onRequestClose={this.handleModalCancel}
          overlayClassName="TCPModal__Overlay"
          className={isMobileView ? 'TCPModal__Content' : className}
          maxWidth="500px"
          minHeight="90%"
          heightConfig={{ height: '90%' }}
          closeIconDataLocator="details-cross-icon"
          fixedWidth
          contentLabel={renderLabel(
            this.shippingPageLabels?.lbl_giftServices_help,
            'lbl_giftServices_help'
          )}
          inheritedStyles={styles}
          spc
        >
          <GiftServicesHeaderContent
            isMobileView={isMobileView}
            labels={labels}
            addGiftServicesTitle={addGiftServicesTitle}
            handleChange={this.handleChange}
            isModalOpen={isModalOpen}
          />
          {getGiftServicesContent({ isMobileView, isShippingCheckboxSelected }) && (
            <>
              <Row fullBleed className="giftServicesContainer">
                <BodyCopy
                  className="addReceipt"
                  fontFamily="secondary"
                  fontSize="fs14"
                  fontWeight="regular"
                  textAlign="left"
                  dataLocator={getLocator('addMessage_txt')}
                >
                  {renderLabel(
                    this.shippingPageLabels?.lbl_giftServices_add,
                    'lbl_giftServices_add'
                  )}
                  {renderLabel(
                    this.shippingPageLabels?.lbl_giftServices_select,
                    'lbl_giftServices_select'
                  )}
                </BodyCopy>
                <Col colSize={{ small: 4, medium: 4, large: 6 }} className="phone-field-wrapper">
                  <Field
                    component={LabeledRadioButton}
                    key={GIFT_SERVICES_CONSTANTS.TCP}
                    selectedValue={GIFT_SERVICES_CONSTANTS.TCP}
                    name="brand"
                    disabled={false}
                    aria-label={BRAND_NAMES.tcp}
                    className="tcp-radio-button"
                    onChange={(e) => handleToggle(e, GIFT_SERVICES_CONSTANTS.TCP)}
                    checked={SelectedBrand === GIFT_SERVICES_CONSTANTS.TCP}
                  >
                    <BodyCopy color="gray.900" fontSize="fs14" fontFamily="secondary">
                      <Image
                        alt=""
                        className="brand-image"
                        src={getIconPath(`header__brand-tab-tcp`)}
                        data-locator={getLocator('logo_TCP')}
                      />
                    </BodyCopy>
                  </Field>
                </Col>
                <Col colSize={{ small: 4, medium: 4, large: 6 }} className="phone-field-wrapper">
                  <Field
                    component={LabeledRadioButton}
                    key={GIFT_SERVICES_CONSTANTS.GYM}
                    selectedValue={GIFT_SERVICES_CONSTANTS.GYM}
                    aria-label={BRAND_NAMES.gym}
                    className="gym-radio-button"
                    name="brand"
                    disabled={false}
                    onChange={(e) => handleToggle(e, GIFT_SERVICES_CONSTANTS.GYM)}
                    checked={SelectedBrand === GIFT_SERVICES_CONSTANTS.GYM}
                  >
                    <BodyCopy color="gray.900" fontSize="fs14" fontFamily="secondary">
                      <Image
                        alt=""
                        className="brand-image"
                        src={getIconPath(`header__brand-tab-gym`)}
                        data-locator={getLocator('logo_gymboree')}
                      />
                    </BodyCopy>
                  </Field>
                </Col>

                <Col
                  colSize={{ small: 4, medium: 4, large: 2 }}
                  className="phone-field-wrapper snj-label-radio"
                >
                  <Field
                    component={LabeledRadioButton}
                    key={GIFT_SERVICES_CONSTANTS.SNJ}
                    selectedValue={GIFT_SERVICES_CONSTANTS.SNJ}
                    aria-label={BRAND_NAMES.snj}
                    className="snj-radio-button"
                    name="brand"
                    disabled={false}
                    onChange={(e) => handleToggle(e, GIFT_SERVICES_CONSTANTS.SNJ)}
                    checked={SelectedBrand === GIFT_SERVICES_CONSTANTS.SNJ}
                  >
                    <BodyCopy
                      color="gray.900"
                      fontSize="fs14"
                      fontFamily="secondary"
                      className="image-container"
                    >
                      <Image
                        alt=""
                        className="brand-image"
                        src={getIconPath(`header__brand-tab-snj`)}
                        data-locator={getLocator('logo_SNJ')}
                      />
                    </BodyCopy>
                  </Field>
                </Col>
              </Row>
              <Row className="edit-form-css" fullBleed>
                <Col colSize={{ small: 6, medium: 6, large: 6 }}>
                  <div className="select-value-wrapper">
                    <div className="color-selector">
                      <Field
                        width={87}
                        id="optionId"
                        name="optionId"
                        component={({ options, input, selectListTitle }) => (
                          <CustomSelect
                            options={options}
                            activeValue={input.value}
                            activeTitle={this.getActiveTitle(options, input.value)}
                            clickHandler={(e, value) => input.onChange(value)}
                            selectListTitle={selectListTitle}
                            customSelectClassName="gift-services-drop-down"
                            spc
                          />
                        )}
                        options={giftServicesList}
                        dataLocator={getLocator('giftService_list')}
                        clickHandler={this.giftServiceChanged}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
              {!isNoneSelected &&
                getTextFieldHeadingText(labels, maxLength, message, textFieldMessage)}
              {isMobileView && (
                <Col colSize={{ small: 6, medium: 8, large: 12 }}>
                  <Button
                    className="elem-mt-LRG"
                    buttonVariation="fixed-width"
                    fill="BLUE"
                    type="button"
                    onClick={this.handleMobileSaveAndContinue}
                    spc
                  >
                    {renderLabel(
                      this.addressLabels?.lbl_addEditAddress_saveAndContinue,
                      'lbl_addEditAddress_saveAndContinue'
                    )}
                  </Button>
                </Col>
              )}
            </>
          )}
          <GiftServicesDetailsModal
            labels={labels}
            openState={detailStatus}
            onRequestClose={() => {
              this.setState({
                detailStatus: false,
              });
            }}
            heading={renderLabel(
              this.shippingPageLabels?.lbl_giftServices_header,
              'lbl_giftServices_header'
            )}
            brand={SelectedBrand}
            dataLocator={getLocator('details_modal')}
          />
        </MainContainer>
      </form>
    );
  }
}

GiftServices.propTypes = {
  className: PropTypes.string,
  isGiftServicesChecked: PropTypes.bool,
  labels: PropTypes.shape({}).isRequired,
  dispatch: PropTypes.func,
  giftWrapOptions: PropTypes.shape({}).isRequired,
  initialValues: PropTypes.shape({}),
  handleToggle: PropTypes.func.isRequired,
  SelectedBrand: PropTypes.string.isRequired,
  handleAnalytics: PropTypes.func.isRequired,
  getGiftServicesContentTcpInfo: PropTypes.shape({}).isRequired,
  getGiftServicesContentGymInfo: PropTypes.shape({}).isRequired,
  giftServicesInputs: PropTypes.shape({}).isRequired,
  deselectCallback: PropTypes.func,
  addressLabels: PropTypes.shape({}).isRequired,
  spc: PropTypes.bool,
  savedGiftService: PropTypes.shape({}).isRequired,
};

GiftServices.defaultProps = {
  className: '',
  isGiftServicesChecked: false,
  dispatch: () => {},
  initialValues: {},
  deselectCallback: () => {},
  spc: false,
};

GiftServicesHeaderContent.propTypes = {
  isMobileView: PropTypes.bool,
  labels: PropTypes.shape({}).isRequired,
  addGiftServicesTitle: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool,
};

GiftServicesHeaderContent.defaultProps = {
  isMobileView: false,
  isModalOpen: false,
};

export { GiftServices as GiftServicesVanilla };

const mapStateToProps = (state, ownProps) => {
  return {
    initialValues: getInitialValues(ownProps),
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'GiftServices',
    enableReinitialize: true,

    // a unique identifier for this form
  })(withStyles(GiftServices, styles))
);
